<template>

	<section :class="{'outer-pad': !inStrip, 'opening-panel': !inStrip, 'no-pad-bottom': true, 'padding-top': !inStrip, 'button-only': ( buttonOnly && !newSearch ) }">

		<div>

			<div :class="{'search-box':true,'in-strip':inStrip,secondary:!!secondary,open:newSearch,fixed:fixed,init:init}" v-if="!readOnly">

				<h2 v-html="title" class="title" v-if="!secondary&&!newSearch&&!buttonOnly" />

				<h2 v-html="subTitle" class="sub-title" v-if="newSearch" />

				<span v-if="!inStrip||newSearch||secondary">

					<p v-html="description" v-if="description" />

					<div class="search-input-wrap" v-if="inputSettings">

						<FormInput 
							:type="inputSettings.type" 
							theRef="keywordsEntry"
							v-model="searchTerm" 
							:noMarginBottom="true"
							:placeholder="inputSettings.placeholder"
							:autoResize="true"
							:autoResizeMaxHeight="60"
							@has-internal-errors="hasErrors"
						/>

					</div>

					<div class="search-input-wrap checkbox" v-if="domainCheckBoxLabel!==''&&!hasURLerror">

						<FormInput
							type="checkbox"
							name="url-default-action"
							id="url-default-action"
							:inline="true"
							v-model="urlDefaultAction"
							fontSize="14"
							:label="domainCheckBoxLabel"
							class="inline-block"
						/>

					</div>

					<div class="search-select-wrap" v-if="dropdownSettings.options.length>0">

						<v-select 
							:placeholder="dropdownSettings.placeholder"
							v-model="dropdownSelection" 
							:options="dropdownSettings.options" 
							:reduce="option => option._id" 
						/>

					</div>

					<div class="search-select-wrap select2" v-if="dropdown2Settings.options.length>0">

						<v-select 
							:placeholder="dropdown2Settings.placeholder"
							v-model="dropdown2Selection" 
							:options="dropdown2Settings.options" 
							:reduce="option => option._id" 
						/>

					</div>

					<div class="search-submit-wrap" v-if="analysisCreditsInfoLoaded">

						<a v-if="!readOnly" :class="{'large-button':true, full: true, 'flip-colours': true, mini: inStrip&&!secondary,errored:errored,credits:!!credits}" @click="submit" :href="searchLink" :target="newTab&&'_blank'">Run<span v-if="inStrip&&newSearch&&newTab"> &nbsp;<font-awesome-icon icon="external-link-alt" :style="{ color: '#FFFFFF' }" /></span><span class="credits" v-if="credits" v-html="credits" /></a>
						<span :class="{'large-button':true, full: true, 'flip-colours': false, mini: inStrip&&!secondary}" v-html="'Cancel'" @click="reset" v-if="!readOnly&&inStrip&&newSearch&&!openByDefault" />

						<p class="invalid" v-if="hasError!==''" v-html="hasError" />

					</div>

					<h3 v-html="analysisCreditsInfoLoaded?title:'Loading...'" class="title bottom" v-if="secondary" />

				</span>

				<span v-if="inStrip&&!newSearch&&!secondary&&!readOnly">

					<span :class="{'large-button':true, full: true, 'flip-colours': true, mini: inStrip&&!secondary}" v-html="'New Search'" @click="newSearch=true" />

				</span>

				<p v-if="openByDefault">Keyword ideas are free, they do not use any analysis credits.</p>

			</div>

			<div :class="{export:true,hasFile:!!filename}" v-if="showExports&&!newSearch">

				<FormInput
					type="checkbox"
					name="hide-current"
					id="hide-current"
					:inline="true"
					v-model="hideFromExport[tabId]"
					fontSize="14"
					label="Hide current <br />from export"
					class="inline-block checkbox-label-line-split"
					v-if="tabId!=='stats'"
				/>

				&nbsp; <Tip v-if="tabId!=='stats'" class="mini">Hide from Current Export - This option allows you to hide the current tab from the full export.</Tip> &nbsp;&nbsp;&nbsp;
				<p v-if="creatingReport" class="creating-report">Creating your report...</p>

				<span class="large-button mini" @click="createReport(false)" v-if="!creatingReport&&tabId!=='stats'">Export Current</span>

				<span class="large-button mini flip-colours last-button" @click="createReport(true)" v-if="!creatingReport">Export All</span> &nbsp;&nbsp;
				<Tip v-if="tabId!=='stats'" class="mini">There are 2 export options. You can export the current tab or you can use the Export All option to export all tabs to Excel. You also have the option to hide some data elements in certain tabs (e.g. questions in the People Also Ask tab).</Tip>

			</div>

		</div>

	</section>

</template>

<script>
import FormInput from './../Form/Input.vue'
import Tip from './../Tip.vue'
import { mapState } from 'vuex'
export default {
	name: 'SearchBox',
	components: { FormInput, Tip },
	props: {
		newTab: {
			type: Boolean,
			default: true
		},
		openByDefault: {
			type: Boolean,
			default: false
		},
		title: {
			type: String
		},
		filter: {
			type: String
		},
		tabId: {
			type: String
		},
		description: {
			type: String
		},
		formInput: {
			type: Object,
			default: () => { return {}; }
		},
		dropdown: {
			type: Object,
			default: () => { return {}; }
		},
		dropdown2: {
			type: Object,
			default: () => { return {}; }
		},
		pageType: {
			type: String,
			default: "keyword"
		},
		inStrip: {
			type: Boolean,
			default: false
		},
		showExports: {
			type: Boolean,
			default: true
		},
		secondary: {
			type: String,
			default: ''
		},
		hideFromExport: {
			type: Object
		},
		triggerNewSearch: {
			type: Boolean,
			default: false
		},
		init: {
			type: Boolean,
			default: false
		},
		creatingReport: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		},
		buttonOnly: {
			type: Boolean,
			default: false
		},
		readOnly: {
			type: Boolean,
			default: false
		}
	},
	data() {

		return {
			searchTerm: '',
			dropdownSelection: null,
			dropdown2Selection: null,
			hasError: '',
			blah: false,
			hideCurrent: false,
			newSearch: false,
			hasURLerror: false,
			urlDefaultAction: true,
			filename: ''
		}

	},
	watch: {
		searchTerm() {
			this.hasError = '';
		},
		dropdownSelection() {
			this.hasError = '';
		},
		dropdownSelection2() {
			this.hasError = '';
		},
		dropdown: {
			handler() {
				this.dropdownSelection = null
			},
			deep: true
		},
		dropdown2: {
			handler() {
				this.dropdownSelection2 = null
			},
			deep: true
		}
	},
	computed: {

		...mapState('general',['analysisCreditsInfo','analysisCreditsInfoLoaded']),

		defaultFilename () {

			return this.title.replaceAll(' - ',' ').replaceAll(' ','-').toLowerCase() + '.xlsx';

		},

		subTitle() {

			let s =  "New " + ( this.pageType === 'domain' ? "Domain/URL" : "Keyword" ) + " Search";

			if (this.pageType !== 'domain'  ) {

				s += " (keyword ideas are free, they do not use any analysis credits.)";

			}

			return s;

		},

		credits () {

			if ( this.secondary && this.analysisCreditsInfoLoaded ) {

				if ( this.analysisCreditsInfo.costs[this.secondary] && this.analysisCreditsInfo.costs[this.secondary] > 0 ) {

					return this.analysisCreditsInfo.costs[this.secondary] + ' Credit' + ( this.analysisCreditsInfo.costs[this.secondary] > 1 ? 's' : '' );

				}

				return 'Free';

			}

			return null;

		},

		domainCheckBoxLabel () {

			if ( this.pageType === 'domain' ) {

				try {

					let urlInfo = new URL(this.searchTerm);

					return urlInfo.pathname === '/' ? "Use entire site to generate keywords (untick for home page only)" : "Generate keywords using this URL only (untick to use entire site)";

				}
				catch (err) {}

			}

			return '';

		},

		searchLink () {

			let url = ['content-and-keywords','search'], notset = 'null', c;

			url.push( encodeURIComponent( this.searchTerm ) );

			c = this.dropdownSelection || notset;

			url.push( c );

			c = this.dropdown2Selection || notset;

			url.push( c );
			
			return '/' + url.join('/') .replaceAll('//','/');

		},
		
		inputSettings () {

			if ( Object.keys( this.formInput ).length === 0 ) return false;

			let defaults = {
				type: 'text',
				placeholder: ''
			};

			return Object.assign( defaults, this.formInput );

		},
		dropdownSettings () {

			let defaults = {
				options: [],
				placeholder: ''
			};

			return Object.assign( defaults, this.dropdown );

		},
		dropdown2Settings () {

			let defaults = {
				options: [],
				placeholder: ''
			};

			return Object.assign( defaults, this.dropdown2 );

		},

		errored () {

			return this.hasError !== '' || this.hasURLerror;

		}

    },
	created() {

		if ( this.dropdown && this.dropdown.value ) this.dropdownSelection = this.dropdown.value;
		if ( this.dropdown2 && this.dropdown2.value ) this.dropdown2Selection = this.dropdown2.value;
		if ( this.inputSettings && this.inputSettings.value ) this.searchTerm = this.inputSettings.value;
		if ( this.triggerNewSearch || this.openByDefault ) this.newSearch = true;

	},
	methods: {

		hasErrors (info) {	
			
			this.hasURLerror = !!info.error;

		},

		createReport (all) {

			if ( this.creatingReport ) return;

			this.$emit('create-report', all);

		},

		reset() {

			this.newSearch = false;
			this.$emit('reset');

		},

		submit (e) {

			let errors = [];

			if ( this.inputSettings && !this.searchTerm ) {

				errors.push('enter a keyword');

			}

			if ( this.dropdown.options && this.dropdown.options.length > 0 && !this.dropdownSelection ) {

				errors.push( this.dropdown.error );

			}

			if ( errors.length === 0 && this.newSearch ) {

				this.reset();
				return;

			}

			if ( e ) e.preventDefault();

			this.hasError = errors.length > 0 ? ( 'Please ' + errors.join(' and ') ) : '';

			if ( !this.errored ) {

				let info = this.inputSettings ? { type: 'keywords', searchTerm: this.searchTerm } : {};

				if ( this.dropdownSelection ) info.dropdown = this.dropdownSelection;

				if ( this.dropdown2Selection ) info.dropdown2 = this.dropdown2Selection;
				
				if ( this.inputSettings ) {

					info.urlDefaultAction = !!this.urlDefaultAction;

				}

				this.$emit('submit', info);

			}

		}

	}
}
</script>

<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.creating-report {

	display: inline-block;
	margin: 0;
	padding: 0;
	font-weight: @bold;

}
.filename {
	width: 100%;
	margin-top: 20px;
	text-align: inherit;
}
.search-box {

	text-align: center;
	padding: 10px 0;
	position: relative;

	.search-input-wrap, .search-select-wrap, .search-submit-wrap {

		margin: 0 auto;
		max-width: 600px;

		.large-button {

			width: 150px;
			position: relative;

			&.credits {

				.vertical-align-parent;
				padding-right:50px;
				
				&.mini {

					padding-right:46px;

				}

			}

			.credits {

				.vertical-align;
				font-size:0.55em;
				text-transform: none;
				background-color: #fff;
				color: @formDefaultColour;
				padding: 1px 3px 0 2px;
				right: 6px;
				border-radius: 3px;
				
			}

		}

		&.select2 {

			margin-top: 10px;

		}

	}

	.search-input-wrap {

		margin-bottom: 10px;

	}

	.search-select-wrap {

		max-width: 400px;

	}

	p {

		&.invalid {

			color: @formDefaultColour;

		}

	}

	&.secondary {

		margin: 10vh 0;
		display: block;
		text-align: center;

		p {
			 
			display: block;
			margin-top: 0;

		}

		.invalid {

			position: absolute;
			bottom: -30px;
			padding: 0;
			margin: 0;
			left: 0;
			width: 100%;

		}

	}

	.title {

		&.bottom {

			margin-top: 20px;

		}

	}

	.large-button {

		&.errored {

			cursor: not-allowed;
			.opacity(0.5);

		}

	}

	.sub-title {

		display: none;
		color: white;
		margin: 0 0 5px;
		padding: 0;
		font-weight: normal;
		font-size: 16px;

	}

	&.init {

		background-color: @darkContrast;
		max-width: 700px;
		padding: 40px;
		border-radius: 10px;
		margin: 0 auto;

		p {

			padding-top: 20px;
			color: #fff;

			&.invalid {

				color: @formDefaultColour;

			}

		}

	}

	&.in-strip {

		.title {

			font-size: 20px;

		}
		
		.large-button {

			width: auto !important;

		}

		&.button-only {

			display: inline-block;

			.large-button {

				margin: 0 0 0 30px;

			}

		}

		&.open {

			background-color: @darkContrast;
			display: block;
			padding: 10px 15px 14px;
			margin-top: 5px;
			.rounded(5px);

			.sub-title {

				display: block;

			}

			&.fixed {

				position: fixed;
				z-index: 10;
				width: 90%;
				left: 5%;
				border: 2px solid #fff;
				box-shadow: 0 5px 22px 0 rgba(0, 0, 0, 0.25);

			}

		}

	}

}
.button-only {

	display: block;
	text-align: center;

	.in-strip {

		display: inline-block;

		.large-button {

			margin: 0 auto;

		}

	}

	.export {

		display: inline-block;
		margin: 0 10px;

		&.hasFile {

			display: block;
			margin: 0 0 30px;

		}

	}

}

.export {

	text-align: center;

}

@media screen and (min-width: 520px) {

	.button-only {

		text-align: left;

		.in-strip {

			display: inline-block;

			.large-button {

				margin: 0 auto;

			}

		}

	}

	.filename {
		display: inline-block;
		margin-left: 20px;
		width: auto;
	}

}

@media screen and (min-width: 960px) {

	.search-box {

		padding: 40px 0;

		.title {

			&.bottom {

				margin-top: 0;

			}
			
		}

		&.secondary {

			margin: 30vh 0;
			padding: 0;

		}

	}
	
	.in-strip {

		text-align: left;
		padding: 20px 10px 0;
		
		.search-input-wrap, .search-select-wrap {

			width: 200px;
			margin-bottom: 0;

			&.select2 {

				margin-top: 0px;
				width: 160px;

			}

		}

		.search-input-wrap {

			width: 12vw;

		}

		.title, p, .search-input-wrap, .search-select-wrap, .search-submit-wrap {

			display: inline-block;
			vertical-align: top;
			max-width: none;
			margin-right: 10px;
			vertical-align: middle;

			.large-button {

				width: 130px;

			}

		}

		.large-button {

			margin: 0;

		}

	}

	.in-strip, .export {

		text-align: left;
		display: inline-block;

	}

	.button-only {

		display: inline-block;
		padding: 0;

		.in-strip {

			padding: 0;
			

			.large-button {

				margin: 0 0 0 30px;

			}

		}

		.export {

			display: inline-block;

		}

	}

}

@media screen and (min-width: 1024px) {
	
	.in-strip {

		padding: 0;

		.search-input-wrap, .search-select-wrap {

			width: 220px;

			&.select2 {

				width: 215px;

			}

		}

	}

	.search-box {

		&.in-strip {

			&.open {

				&.fixed {

					width: 900px;
					left: auto;
					right: 40px;

				}

			}

		}

	}

	.button-only {

		.in-strip {

			.large-button {

				margin-top:3px;

			}

		}

		.export {

			.large-button {

				margin-top:3px;

			}

		}

	}

}

@media screen and (min-width: 1240px) {
	
	.export {

		margin-left: 20px;

	}

	.in-strip {

		.search-input-wrap, .search-select-wrap {

			&.select2 {

				width: 290px;

			}

		}

	}

	.search-box {

		&.in-strip {

			&.open {

				&.fixed {

					width: 1000px;

				}

			}

		}

	}

}

@media screen and (min-width: 1350px) {
	
	.in-strip {

		.search-input-wrap {

			width: 18vw

		}

	}

}

@media screen and (min-width: 1440px) {
	
	.in-strip, .export {

		.large-button {

			&.last-button {

				margin-left: 10px;

			}

		}

	}

	.export {

		margin-left: 30px;

	}

	.in-strip {

		.search-input-wrap, .search-select-wrap, .search-submit-wrap {

			.large-button {

				width: 140px;

			}

		}

		.search-input-wrap {

			width: 220px;

		}

		.search-select-wrap {

			width: 220px;

			&.select2 {

				width: 300px;

			}

		}

	}
	
}
</style>